export default {
    primaryColor: "#CE1141",
    primaryColorDark: "#A80F36",
    primaryColorLight: "#E27C96",
    primaryColorLighter: "#E27C96",
    accentColor: "#009FC2",
    textColorPrimary: "#333333",
    textColorSecondary: "#878787",
    disabledControl: "#68737A",
    disabledControlLighter: "#D2D2D4",
    shadowColor: "#EAEFF2",
    shadowColorLight: "#FAF8FC",
    shadowColorMedium: "#577E9F",
    redDark: "#CE1141",
    redLight: "#A80F36",
    lighterColor: "white",
    disabledColor: "#68737A",
    placeholderInput: "#767676",
    disabledInput: "#343434",
};
